"use client";

import { createTheme } from "@mui/material";
import { Typography } from "./typography";
import Components from "./components";
import { PalletesDark, PalletesLight } from "./palettes/palettes";

export const Colors = [
    "primary",
    "secondary",
    "success",
    "error",
    "info",
    "warning",
] as const;
export type ColorType = keyof (typeof Colors)[number];

export const StandardThemeLight = createTheme({
    palette: PalletesLight,
    components: Components,
    typography: Typography,
});

export const StandardThemeDark = createTheme({
    palette: PalletesDark,
    components: Components,
    typography: Typography,
});

export const StandardTheme = {
    dark: StandardThemeDark,
    light: StandardThemeLight,
};

export default StandardTheme;
